// extracted by mini-css-extract-plugin
module.exports = {"notification":"TabNotification_notification_8MUSc"};